// pages/auth/pending-approval/pending-approval.page.ts

import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-pending-approval',
  templateUrl: './pending-approval.page.html',
  styleUrls: ['./pending-approval.page.scss'],
  standalone: true,
  imports: [CommonModule, ButtonModule, CardModule]
})
export class PendingApprovalPage implements OnInit {
  userName = '';
  isChecking = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.authService.user$.subscribe(user => {
      if (user) {
        this.userName = user.displayName || user.email || '';
      }
    });
  }

  async checkStatus() {
    this.isChecking = true;
    try {
      const response = await firstValueFrom(
        this.http.get<any>(`${environment.apiUrl}/regional/users/state`)
      );
      
      if (response.status === 'success') {
        // User is approved, reload to get new claims
        window.location.href = '/dashboard';
      }
    } catch (error: any) {
      // Still pending or other error
      console.log('Still pending approval');
    }
    this.isChecking = false;
  }

  async logout() {
    await this.authService.logout();
    this.router.navigate(['/auth/login']);
  }
}